import './SectionWrap.css'


function SectionWrap(props) {
  return (
    <>
    <div className='section-wrap'>
        {props.children}
    </div>
    </>
  )
}

export default SectionWrap